import React from "react";
import { GetStarted } from "./GetStarted";
import { Login } from "./Login";
import { Signup } from "./Signup";

export const Auth = ({ type = "getstarted" }) => {
  const types = {
    getstarted: <GetStarted />,
    signup: <Signup />,
    login: <Login />,
  };

  return <div>{types[type]}</div>;
};
